import apiClient from '../utils/apiClient';

export const getFCDataByDeviceName = async deviceName => {
  try {
    const response = await apiClient.get(
      `/values/Measurement?name=${deviceName}`,
      {
        headers: {
          'Cache-Control': 'no-cache',
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error fetching measurement data:', error);
    throw error;
  }
};
